import { render, staticRenderFns } from "./PublicNav.vue?vue&type=template&id=089e77c8&scoped=true&"
import script from "./PublicNav.vue?vue&type=script&lang=js&"
export * from "./PublicNav.vue?vue&type=script&lang=js&"
import style0 from "./PublicNav.vue?vue&type=style&index=0&id=089e77c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089e77c8",
  null
  
)

export default component.exports